import React from 'react'

function GeneralSupplies() {
  return (
    <div>GeneralSupplies</div>
  )
}

export default GeneralSupplies